import 'isotope-layout/dist/isotope.pkgd.min';



// WEBPACK FOOTER //
// ./scripts/autoload/_isotope.js